(function () {
    'use strict';

    // @ngInject
    function BatchEmailsControllerCtor($scope, $injector, ModalService, $log, UsersManager, moment, PopupMessageService, AnalyticsService, $translate, $window, UIUtils, $sce, $interval, ToastService, _) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'BatchEmailsController';

        AnalyticsService.trackPageView(this, 'batch emails');
        this.$log = $log;
        this.moment = moment;
        this.$window = $window;
        this.AnalyticsService = AnalyticsService;
        this.UIUtils = UIUtils;
        this.$sce = $sce;
        this.$interval = $interval;
        this._ = _;

        this.UsersManager = UsersManager;
        this.PopupMessageService = PopupMessageService;
        this.ModalService = ModalService;
        this.UsersManager = UsersManager;
        this.$translate = $translate;
        this.ToastService = ToastService;

        this.user = this.UsersManager.getCurrUser();

        this.batchEmailsSentList = null;
        this.sendInterval = null;

        this.userSentBatchEmailsBefore = false;
        this.isLoading = true;
        this.isSendingEmails = false;
        this.STATUS_CHECK_INTERVAL = 5000;

        this.emptyState = {
            title: $translate.instant('BATCH_EMAILS.LAST_SENT._TITLE_'),
            body: $translate.instant('BATCH_EMAILS.LAST_SENT._DESCRIPTION_'),
            cta: $translate.instant('BATCH_EMAILS.LAST_SENT._CREATE_BUTTON_')
        };

        this.expandedListItems = {};

        this.sortingModel = {
            currentSorting: null,

            subject: {
                sortName: 'subject',
                sortKey: 'subject',
                serverSortKey: 'subject',
                sortReverse: false,
                sortByLabel: 'BATCH_EMAILS.LAST_SENT._SUBJECT_'
            },

            last_sent_time: {
                sortName: 'lastSentTime',
                sortKey: 'last_sent_time',
                serverSortKey: 'last_sent_time',
                sortReverse: true,
                sortByLabel: 'BATCH_EMAILS.LAST_SENT._DATE_SENT_'
            },

            serialize: function () {
                return {sortName: this.currentSorting.sortName, sortReverse: this.currentSorting.sortReverse};
            },

            deserialize: function (serialization) {
                this.currentSorting = this[serialization.sortName];
                this.currentSorting.sortReverse = serialization.sortReverse;
            }
        };

        this.setProTip();
        this.getBatchEmailsHistory();

        $scope.$on('$destroy', function () {
            if (this.sendInterval) {
                this.$interval.cancel(this.sendInterval);
            }
        }.bind(this));
    }

    Controllers.BatchEmailsController = Class(Controllers.BaseController, {
        constructor: BatchEmailsControllerCtor,

        setProTip: function setProTip() {
            this.proTipBoldText = this.$translate.instant('BATCH_EMAILS.LAST_SENT.PRO_TIP._BOLD_');
            this.proTipText = this.$translate.instant('BATCH_EMAILS.LAST_SENT.PRO_TIP._TEXT_');
            this.proTipLinkTitle = this.$translate.instant('BATCH_EMAILS.LAST_SENT.PRO_TIP._LINK_TITLE_');
        },

        onClickProTip: function onClickProTip() {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.help_center, {source: 'batch email'});
            this.$window.open('https://help.honeybook.com/en/articles/3882582-what-s-the-difference-between-bulk-emails-and-batch-emails','_blank');
        },

        toggleLine: function toggleLine(id) {
            this.expandedListItems[id] = !Boolean(this.expandedListItems[id]);
        },

        isExpanded: function isExpanded(id) {
          return Boolean(this.expandedListItems[id]);
        },

        allEmailWereSent: function allEmailsAreDone() {
            return this._.every(this.batchEmailsSentList, function(email) { return email.status === 'done'; });
        },

        getBatchEmailsHistory: function getBatchEmalsHitory() {
            this.batchEmailsPromise = this.UsersManager.getBatchEmails(this.user._id)
                .then(function success(resp) {
                    if (resp.data.batch_emails) {
                        this.batchEmailsSentList = angular.copy(resp.data.batch_emails);
                        this.userSentBatchEmailsBefore = this.batchEmailsSentList.length > 0;
                        this.setSort(this.sortingModel.last_sent_time, true);
                    }
                    this.isLoading = false;
                    return resp;
                }.bind(this))
                .catch(function fail(resp) {
                    this.isLoading = false;
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._COULD_NOT_CONNECT_TO_SERVER_');
                }.bind(this))
            ;
        },

        getCurrEmailOpenRate: function getCurrEmailOpenRate(batchEmailSent) {
            return this.UIUtils.toPercentage(batchEmailSent.opened / batchEmailSent.sent);
        },

        isShowRecipientsList: function isShowRecipientsList(batchEmailSent) {
            return (batchEmailSent.status === 'done' && batchEmailSent.sent > 0);
        },

        _getBatchEmailsStatus: function _getBatchEmailsStatus() {
            this.UsersManager.getBatchEmailsStatus(this.user._id)
                .then(function (response) {
                    this.isSendingEmails = response && response.data && response.data.runnning;
                    if (!this.isSendingEmails) {
                        this.$interval.cancel(this.sendInterval);
                        this.getBatchEmailsHistory();
                        this.showSuccessToast();
                    }
                }.bind(this));
        },

        showSuccessToast: function showSuccessToast() {
            this.ToastService.showSuccess({
                contentTranslation: 'BATCH_EMAILS.LAST_SENT._SUCCESS_TOAST_',
                iconCssClass: 'icon icon-hb-nx-check-mark-circle-16',
                dismissOnTimeout: true,
                dismissButton: true,
                timeout:5000
            });
        },

        getBatchEmailsStatusPeriodically: function getBatchEmailsStatusPeriodically() {
            if (!this.allEmailWereSent() && !this.sendInterval) {
                this.sendInterval = this.$interval(this._getBatchEmailsStatus.bind(this), this.STATUS_CHECK_INTERVAL);
            }
        },

        getEmailBody: function getEmailBody(body) {
          return this.$sce.trustAsHtml(body);
        },

        createBatchEmails: function createBatchEmails() {

            this.batchEmailsPromise
                .then(function success(resp) {
                    if (resp.data.allowed) {
                        //the user could be blocked if he does not have gmail integration
                        this.ModalService.openSendBatchEmailModal(this.getBatchEmailsHistory.bind(this))
                            .then(function success() {
                                this.getBatchEmailsHistory();
                            }.bind(this), function dismissed(){
                                this.getBatchEmailsHistory();
                            }.bind(this));

                        //if you the user canceled we exit this flow quietly
                    } else {
                        if (resp.data.reason === 'premium_feature_only') {
                            this.ModalService.openConfirmPremiumFeature();
                        } else if (resp.data.reason === 'unsupported_email_intg' || resp.data.reason === 'gmail_is_not_selected') {
                            this.ModalService.openConfirmGmailIntegrationNeeded();
                        } else if (resp.data.reason === 'cannot_send_more_then_twice_a_day') {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'BATCH_EMAILS.LAST_SENT._CANNOT_SEND_MORE_THEN_TWICE_A_DAY_');
                        }
                        else {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNEXPECTED_');
                        }
                    }
                }.bind(this))
                .catch(function (res) {
                    if (res && res.data && res.data.error_message) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, res.data.error_message);
                    } else {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNEXPECTED_');
                    }
                }.bind(this))
        },

        emailHasAttachments: function emailHasAttachments(batchEmailSent) {
            return batchEmailSent && (!this._.isEmpty(batchEmailSent.image_attachments) || !this._.isEmpty(batchEmailSent.file_attachments));

        },

        sortIt: function (sortingModel, sortReverse) {
            // Reverse the sort if needed
            if (this.sortingModel.currentSorting.sortKey === sortingModel.sortKey) {
                sortingModel.sortReverse = !sortingModel.sortReverse;
            }
            this.setSort(sortingModel);
        },

        setSort: function (sortingModel) {
            this.sortingModel.currentSorting = sortingModel;
        }
    });
}());
